var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data &&
    _vm.data.reviews &&
    _vm.data.reviews.length >= 1 &&
    _vm.dataLoaded
    ? _c("div", { staticClass: "ts-widget" }, [
        _c("div", { staticClass: "fxc" }, [
          _c("div", { staticClass: "hl" }, [_vm._v(_vm._s(_vm.$attrs.trans4))]),
          _vm._v(" "),
          _c("div", { staticClass: "inner" }, [
            _c(
              "div",
              { staticClass: "glide-badgex" },
              [
                _c(
                  "vue-glide",
                  {
                    ref: "vueglider",
                    attrs: { perView: 1, autoplay: 10000 },
                    on: { "glide:mount-after": _vm.update },
                  },
                  [
                    _vm._l(_vm.data.reviews, function (review, index) {
                      return _c("vue-glide-slide", { key: index }, [
                        _c(
                          "div",
                          { staticClass: "stars" },
                          [
                            _vm._l(review.rating * 1 || 0, function (index) {
                              return [_c("i", { staticClass: "fa fa-star" })]
                            }),
                            _vm._v(" "),
                            _vm._l(
                              5 - (review.rating * 1 || 0),
                              function (index) {
                                return [
                                  _c("i", { staticClass: "fa fa-star grey" }),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "comment",
                          domProps: {
                            innerHTML: _vm._s(
                              review.comment && review.comment.trim()
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "date" },
                          [
                            review.name && review.name.trim() != ""
                              ? [_vm._v(_vm._s(review.name.trim()) + ",")]
                              : [_vm._v("Community-Mitglied,")],
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.formatDate(review.submittedAt)) +
                                "\n                        "
                            ),
                          ],
                          2
                        ),
                      ])
                    }),
                    _vm._v(" "),
                    _c("template", { slot: "control" }, [
                      _c("button", { attrs: { "data-glide-dir": "<" } }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                            },
                          },
                          [_c("use", { attrs: { href: "#svg_arrow" } })]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("button", { attrs: { "data-glide-dir": ">" } }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                            },
                          },
                          [_c("use", { attrs: { href: "#svg_arrow" } })]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "badgex" }, [
                  _c("div", { staticClass: "l" }, [
                    _c("div", { staticClass: "rate-stars" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.data.rating365.toString().replace(".", ",")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "rate-full",
                            style: "width:" + _vm.data.rating365 * 20 + "%",
                          },
                          [
                            _c("i", { staticClass: "fa fa-star" }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fa fa-star" }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fa fa-star" }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fa fa-star" }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fa fa-star" }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm.data.count365) + " "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.$attrs.trans5) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.data.overallCount) +
                          " " +
                          _vm._s(_vm.$attrs.trans6)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://www.trustedshops.de/bewertung/info_X8FBC0170222C357E43FE6B90AEB9A178.html",
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$attrs.trans7) +
                              " " +
                              _vm._s(_vm.formatDate(_vm.data.calculatedAt))
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("svg", { staticClass: "hide" }, [
          _c("g", { attrs: { id: "svg_arrow" } }, [
            _c("rect", { attrs: { width: "20", height: "20", rx: "10" } }),
            _c("g", { attrs: { transform: "translate(7.75 6)" } }, [
              _c("path", {
                attrs: {
                  d: "M4.457.707.707,4.457l3.75,3.75",
                  transform: "translate(-0.707 -0.707)",
                  fill: "none",
                  stroke: "#fff",
                  "stroke-miterlimit": "10",
                  "stroke-width": "1",
                },
              }),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "rate-blank" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.trustedshops.de/bewertung/info_X8FBC0170222C357E43FE6B90AEB9A178.html",
          target: "_blank",
        },
      },
      [
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0AQMAAADxGE3JAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAADVJREFUeNrtwTEBAAAAwiD7p/ZZDGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOX0AAAEidG8rAAAAAElFTkSuQmCC",
            "data-src":
              "https://cdn03.plentymarkets.com/r82ckxwxroh6/frontend/Redesign/img/ts.webp",
            alt: "",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }